(function () {
  function initTabs(root) {
    const tabs = Array.from(root.querySelectorAll('.mb-core-tabs__tab'));
    const panels = Array.from(root.querySelectorAll('.mb-core-tabs__panel'));
    if (!tabs.length || !panels.length) return;

    function activate(tab) {
      tabs.forEach(function (t) {
        const active = t === tab;
        if (active) {
          t.setAttribute('data-active', '');
          t.setAttribute('aria-selected', 'true');
        } else {
          t.removeAttribute('data-active');
          t.setAttribute('aria-selected', 'false');
        }
      });

      panels.forEach(function (p) {
        const isTarget = p.id === tab.getAttribute('aria-controls');
        if (isTarget) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-mb-tabs]').forEach(initTabs);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
